/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import * as actions from 'Actions';
import classnames from 'classnames';
import DateSelector from './DateSelector';
import ColorPicker from 'Utils/ColorPicker';
import Slider, { createSliderWithTooltip } from 'rc-slider';
import ScrollArea from 'Utils/react-scrollbar';
import ShopBreadCrumbs from '../utils/ShopBreadCrumbs';
import SfCategoryTree from './SfCategoryTree';
import { clearFilterParams } from '../../helper_functions/urls';
import withCategoryFilterAutoExpansion from './withCategoryFilterAutoExpansion';

const Range = createSliderWithTooltip(Slider.Range);

class CategoryFilterDesktop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterOpen: false,
    };
  }

  toggleFilter = () => {
    this.setState({
      filterOpen: !this.state.filterOpen,
    });
  };

  checkSfCategorySelected = ({ id }) => {
    const { selectedSfCategories } = this.props;

    return selectedSfCategories.includes(String(id));
  };

  requireRentalDatesBeforePickingInventory = () => {
    return this.props.clientLocation.overbookingOnSf === 'disallowed';
  };

  render() {
    const { theme, editingEvent } = this.props;
    const {
      showFilters,
      onColorSelection,
      selectedColors,
      clearColorSelection,
      onQuantitySelection,
      selectedMinQuantity,
      selectedMaxQuantity,
      storefrontShopSetting,
    } = this.props;
    const allowedFilterList = storefrontShopSetting.allowedFilters.split(',');
    const quantityValues = [+selectedMinQuantity, +selectedMaxQuantity];
    const { filterOpen } = this.state;
    const { currentCategory } = this.props;
    if (
      !(
        allowedFilterList.includes('date') ||
        allowedFilterList.includes('quantity') ||
        allowedFilterList.includes('color') ||
        allowedFilterList.includes('category')
      )
    ) {
      return null;
    }

    const themeOptions = ['wisteria', 'wisteriaDark', 'elaina'];

    return (
      <aside
        className={classnames({
          withEventHeader: editingEvent,
        })}
      >
        {themeOptions.includes(theme) && (
          <a
            className={classnames({
              filterToggle: true,
              open: filterOpen,
            })}
            onClick={this.toggleFilter}
          >
            Filter
          </a>
        )}
        {(!(
          theme === 'wisteria' ||
          theme === 'wisteriaDark' ||
          theme === 'elaina'
        ) ||
          filterOpen) && (
          <div className='filter'>
            <div className={'filterBreadcrumbs'}>
              <div className='breadcrumbs'>
                <ShopBreadCrumbs
                  sfCategories={this.props.sfCategories}
                  currentCategory={currentCategory}
                />
              </div>
              {!!currentCategory && (
                <small
                  className={'clearFilters'}
                  onClick={() => this.props.history.push('/shop')}
                >
                  Clear Filters
                </small>
              )}
            </div>
            {this.requireRentalDatesBeforePickingInventory() && (
              <DateSelector />
            )}
            {showFilters && (
              <div className='filterWrapper'>
                {allowedFilterList.includes('date') &&
                  !this.requireRentalDatesBeforePickingInventory() && (
                    <DateSelector />
                  )}

                {allowedFilterList.includes('quantity') && (
                  <div id='tooltipContainer' className='quantityFilter'>
                    <div
                      ref={(input) => {
                        this.tooltipContainer = input;
                      }}
                    />
                    Quantity
                    <Range
                      allowCross={false}
                      value={quantityValues}
                      onChange={onQuantitySelection}
                      max={500}
                      tipProps={{
                        visible: true,
                        getTooltipContainer: () => this.tooltipContainer,
                      }}
                    />
                  </div>
                )}
                {allowedFilterList.includes('color') && (
                  <div className='colorFilter'>
                    Color
                    <ColorPicker
                      onColorSelection={onColorSelection}
                      selectedColorIds={selectedColors}
                      clearColorSelection={clearColorSelection}
                    />
                  </div>
                )}
              </div>
            )}
            <div className='colorAGroup' id='categoryLinks'>
              <div className={'allCategoriesHeader'}>
                <h4>All Categories</h4>
                {!currentCategory && (
                  <small
                    className={'clearFilters'}
                    onClick={() =>
                      clearFilterParams(this.props.location, this.props.history)
                    }
                  >
                    Clear Filters
                  </small>
                )}
              </div>

              <ScrollArea speed={0.8} horizontal={false}>
                <List className='checkList'>
                  <SfCategoryTree
                    sfCategories={this.props.sfCategories}
                    open={this.props.open}
                    toggleOpen={this.props.toggleOpen}
                    checkCategorySelected={this.checkSfCategorySelected}
                    handleCategorySelected={this.props.handleSfCategorySelected}
                    currentCategory={currentCategory}
                    theme={this.props.theme}
                    showCheckbox={!currentCategory}
                  />
                </List>
              </ScrollArea>
            </div>
          </div>
        )}
      </aside>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { sfCategories } = state.categoryList;
  const { parsedStorefrontSettings, location } = state.locations;
  const theme = parsedStorefrontSettings.mainSetting.theme;
  const storefrontShopSetting = parsedStorefrontSettings.storefrontShopSetting;
  return {
    sfCategories,
    storefrontShopSetting,
    theme,
    clientLocation: location,
    location: ownProps.location,
  };
};

export default connect(
  mapStateToProps,
  actions
)(withCategoryFilterAutoExpansion(CategoryFilterDesktop));
